import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { DateInput } from "@/components/DateInput";
import { fmtDate } from "@/lib/format";

const aiDate = (ai) => {
  const v = (ai?.fields || []).find((f) => f.key === "data_assinatura")?.value;
  return /^\d{4}-\d{2}-\d{2}/.test(v || "") ? v.slice(0, 10) : "";
};

export const SIGNED_KEY = "contrato_mediacao";

export function SignDateDialog({ pid, ai, onClose, onSaved }) {
  const suggested = aiDate(ai);
  const [date, setDate] = useState(suggested);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/processes/${pid}/mediation/signed-date`, { date });
      toast.success(data.renews && data.mediation_end ? `Data guardada · renova-se a ${fmtDate(data.mediation_end)}` : "Data de assinatura guardada");
      onSaved(); onClose();
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="sign-date-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-ec-green">Data de assinatura do CMI</DialogTitle>
          <DialogDescription>Os prazos do contrato contam a partir desta data. No CMI da agência: 180 dias (cláusula 8.ª), com renovação automática.</DialogDescription>
        </DialogHeader>
        <DateInput value={date} max={new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10)} onChange={(e) => setDate(e.target.value)} data-testid="sign-date-input" />
        {suggested && <p className="text-xs text-slate-500" data-testid="sign-date-suggested">Data lida no documento: {fmtDate(suggested)}. Confirme ou corrija.</p>}
        <div className="flex justify-end gap-2 pt-2">
          <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm text-slate-600 hover:bg-slate-100" data-testid="sign-date-later">Mais tarde</button>
          <button onClick={save} disabled={!date || busy} data-testid="sign-date-save"
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-ec-green text-white hover:bg-ec-greenDark disabled:opacity-60">Guardar data</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
